import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, ClockIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-navy py-16 md:py-24 px-4 text-white" data-id="element-65">
      <div className="max-w-3xl mx-auto text-center" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-67">
          <div className="flex justify-center items-center space-x-4 mb-6" data-id="element-68">
            <HeartIcon className="w-10 h-10 text-amber" data-id="element-69" />
            <ClockIcon className="w-10 h-10 text-amber" data-id="element-70" />
          </div>

          <h2 className="font-heading text-3xl md:text-5xl font-bold mb-8 text-cream" data-id="element-71">
            El Método de los Micro-Puentes (2 Minutos)
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-cream/90 leading-relaxed font-body text-left" data-id="element-72">
            <p data-id="element-73">
              Este no es un libro de psicología densa. Es un protocolo de
              intervención basado en la neurociencia del afecto. En lugar de
              largas y pesadas conversaciones, utilizaremos interacciones
              estratégicas de máximo 120 segundos.
            </p>
            <p data-id="element-74">
              Estas "micro-conexiones" están diseñadas para bajar las defensas
              biológicas de tu hijo, demostrándole a su sistema nervioso que tú
              eres un territorio seguro, no una amenaza.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}